export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9183.3929a91c.jpg";